import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useFacet } from '~/composables/_next/useFacet';
import { getFacetProducts, getFacetGrouped } from '~/composables/_next/facetGetters';
import { useSearchFacets } from '~/composables/_next/useSearchFacets';
import { useTrpc } from '~/composables/_next/useTrpc';
import { PROBLEM_LABELS } from '~/types/FiltersConst';
import { ProductAttributes } from '~/types/ProductEnums';
import { alphabetChars } from '~/utils/alphabet';
import { useLocalization } from '~/composables/_next/useLocalization';
export function useEssentialOilListingStore() {
  var _useNuxt2App = useNuxt2App(),
    i18n = _useNuxt2App.i18n;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var route = useRoute();
  var isFirstTimeFetching = useState('essential-oil-listing-page-first-time-flag', function () {
    return true;
  });
  var essentialOilListingPage = useState('essential-oil-listing-page', function () {
    return null;
  });
  var essentialOilListingContentProducts = useState('essential-oil-listing-content-products', function () {
    return null;
  });
  var essentialOilListingProducts = useState('essential-oil-products', function () {
    return null;
  });
  var essentialOilSkus = useState('essential-oils-skus', function () {
    return [];
  });
  var _useSearchFacets = useSearchFacets(),
    facets = _useSearchFacets.facets;
  var _useFacet = useFacet('essential-oil'),
    productResult = _useFacet.result,
    searchEssentialOils = _useFacet.searchEssentialOils;
  function fetchEssentialOilListingContent() {
    return _fetchEssentialOilListingContent.apply(this, arguments);
  }
  function _fetchEssentialOilListingContent() {
    _fetchEssentialOilListingContent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _content$data, _content$data$pagePro;
      var content;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.contentful.getOilListingPage.query({
              locale: locale
            });
          case 2:
            content = _context.sent;
            essentialOilListingPage.value = (_content$data = content.data) === null || _content$data === void 0 ? void 0 : (_content$data$pagePro = _content$data.pageProductInformationsListingPageCollection) === null || _content$data$pagePro === void 0 ? void 0 : _content$data$pagePro.items[0];
            return _context.abrupt("return", essentialOilListingPage.value);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchEssentialOilListingContent.apply(this, arguments);
  }
  function fetchEssentialOilListing() {
    return _fetchEssentialOilListing.apply(this, arguments);
  }
  function _fetchEssentialOilListing() {
    _fetchEssentialOilListing = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _essentialOilSkus$val2, _facets$value$Product, _facets$value$Product2;
      var skus, hasFacetBeauty, hasFacetWelness, hasFacets;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if ((_essentialOilSkus$val2 = essentialOilSkus.value) !== null && _essentialOilSkus$val2 !== void 0 && _essentialOilSkus$val2.length) {
              _context2.next = 4;
              break;
            }
            _context2.next = 3;
            return client.contentful.getProductSKUs.query({
              locale: locale
            });
          case 3:
            essentialOilSkus.value = _context2.sent;
          case 4:
            if (essentialOilListingProducts.value) {
              _context2.next = 8;
              break;
            }
            _context2.next = 7;
            return searchEssentialOils({
              page: 1,
              filters: {
                skus: essentialOilSkus.value.map(function (_ref5) {
                  var sku = _ref5.sku;
                  return sku;
                })
              },
              sort: 'latest',
              itemsPerPage: 500
            });
          case 7:
            essentialOilListingProducts.value = Object.assign({}, productResult.value);
          case 8:
            if (!(essentialOilsAll.value.length === 0)) {
              _context2.next = 13;
              break;
            }
            skus = essentialOilSkus.value.map(function (_ref6) {
              var sku = _ref6.sku;
              return sku;
            });
            _context2.next = 12;
            return client.contentful.getOilListingPageProducts.query({
              locale: locale,
              limit: essentialOilSkus.value.length,
              skip: 0,
              firstLetterTitle: alphabetChars,
              productSkuAssociated: skus
            });
          case 12:
            essentialOilListingContentProducts.value = _context2.sent;
          case 13:
            hasFacetBeauty = ((_facets$value$Product = facets.value[ProductAttributes.beautyProblems]) === null || _facets$value$Product === void 0 ? void 0 : _facets$value$Product.length) > 0;
            hasFacetWelness = ((_facets$value$Product2 = facets.value[ProductAttributes.wellnessProblems]) === null || _facets$value$Product2 === void 0 ? void 0 : _facets$value$Product2.length) > 0;
            hasFacets = hasFacetWelness || hasFacetBeauty;
            if (!(hasFacets || !isFirstTimeFetching.value && !hasFacets)) {
              _context2.next = 19;
              break;
            }
            _context2.next = 19;
            return searchEssentialOils({
              page: 1,
              filters: _objectSpread(_objectSpread({}, facets.value), {}, {
                skus: essentialOilSkus.value.map(function (_ref7) {
                  var sku = _ref7.sku;
                  return sku;
                })
              }),
              sort: 'latest',
              itemsPerPage: 500
            });
          case 19:
            isFirstTimeFetching.value = false;
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _fetchEssentialOilListing.apply(this, arguments);
  }
  var essentialOilsListingContentProductsFiltered = computed(function () {
    var _ref, _route$query$letter, _essentialOilSkus$val, _essentialOilsAll$val;
    var filteredEssentialOilSkus = getFacetProducts(productResult.value).flatMap(function (product) {
      return product === null || product === void 0 ? void 0 : product.sku;
    });
    var currentSelectedLetter = (_ref = (_route$query$letter = route.query.letter) !== null && _route$query$letter !== void 0 ? _route$query$letter : essentialOilListingSelectedLetter.value[0]) !== null && _ref !== void 0 ? _ref : 'A';
    var remainingLetters = (_essentialOilSkus$val = essentialOilSkus.value) === null || _essentialOilSkus$val === void 0 ? void 0 : _essentialOilSkus$val.map(function (_ref2) {
      var letter = _ref2.letter;
      return letter;
    }).filter(function (letter) {
      return letter >= currentSelectedLetter;
    });
    var items = (_essentialOilsAll$val = essentialOilsAll.value.filter(function (item) {
      return remainingLetters.includes(item.firstLetterTitle) && filteredEssentialOilSkus.includes(item.productSkuAssociated);
    })) !== null && _essentialOilsAll$val !== void 0 ? _essentialOilsAll$val : [];
    var ITEM_PER_PAGE = 30;
    var skip = ITEM_PER_PAGE * (route.query.page - 1) || 0;
    var itemsPage = items.slice(skip, skip + ITEM_PER_PAGE);
    return {
      items: itemsPage,
      skip: skip,
      total: items.length
    };
  });
  var essentialOils = computed(function () {
    var _essentialOilsListing;
    return (_essentialOilsListing = essentialOilsListingContentProductsFiltered.value.items) !== null && _essentialOilsListing !== void 0 ? _essentialOilsListing : [];
  });
  var essentialOilsAll = computed(function () {
    var _essentialOilListingC, _essentialOilListingC2, _essentialOilListingC3, _essentialOilListingC4;
    return (_essentialOilListingC = (_essentialOilListingC2 = essentialOilListingContentProducts.value) === null || _essentialOilListingC2 === void 0 ? void 0 : (_essentialOilListingC3 = _essentialOilListingC2.data) === null || _essentialOilListingC3 === void 0 ? void 0 : (_essentialOilListingC4 = _essentialOilListingC3.pageProductInformationsCollection) === null || _essentialOilListingC4 === void 0 ? void 0 : _essentialOilListingC4.items) !== null && _essentialOilListingC !== void 0 ? _essentialOilListingC : [];
  });
  var essentialOilsPagination = computed(function () {
    var total = essentialOilsListingContentProductsFiltered.value.total;
    return {
      count: Math.ceil(total / 30),
      total: total
    };
  });
  var essentialOilListingFacets = computed(function () {
    var _problemFacets$subfac;
    if (!essentialOilListingProducts.value) return [];
    var facets = getFacetGrouped(essentialOilListingProducts.value, _toConsumableArray(PROBLEM_LABELS)).filter(function (facet) {
      var _facet$options;
      return (_facet$options = facet.options) === null || _facet$options === void 0 ? void 0 : _facet$options.length;
    });
    var result = [];
    var problemFacets = {
      id: 'problems',
      label: i18n.t('search.filters.problems'),
      type: 'nested',
      subfacets: [],
      defaultOpened: true
    };
    facets.forEach(function (facet) {
      var _facet$options2;
      facet.label = i18n.t("search.filters.".concat(facet.id));
      if (/^problematiques-/.test(facet.id) && (_facet$options2 = facet.options) !== null && _facet$options2 !== void 0 && _facet$options2.length) {
        problemFacets.subfacets.push(facet);
      } else {
        result.push(facet);
      }
    });
    if ((_problemFacets$subfac = problemFacets.subfacets) !== null && _problemFacets$subfac !== void 0 && _problemFacets$subfac.length) result.push(problemFacets);
    return result;
  });
  var essentialOilListingLetterFilters = computed(function () {
    var filteredEssentialOilSkus = new Set(getFacetProducts(productResult.value).flatMap(function (product) {
      return product === null || product === void 0 ? void 0 : product.sku;
    }));
    return essentialOilSkus.value.flatMap(function (_ref3) {
      var sku = _ref3.sku,
        letter = _ref3.letter;
      return filteredEssentialOilSkus.has(sku) ? [letter] : [];
    }).sort();
  });
  var essentialOilListingSelectedLetter = computed(function () {
    var _ref4, _route$query$letter2;
    return (_ref4 = (_route$query$letter2 = route === null || route === void 0 ? void 0 : route.query.letter) !== null && _route$query$letter2 !== void 0 ? _route$query$letter2 : essentialOilListingLetterFilters.value[0]) !== null && _ref4 !== void 0 ? _ref4 : 'A';
  });
  return {
    essentialOilListingPage: essentialOilListingPage,
    fetchEssentialOilListingContent: fetchEssentialOilListingContent,
    essentialOils: essentialOils,
    essentialOilsAll: essentialOilsAll,
    essentialOilsPagination: essentialOilsPagination,
    fetchEssentialOilListing: fetchEssentialOilListing,
    essentialOilSkus: readonly(essentialOilSkus),
    essentialOilListingProducts: essentialOilListingProducts,
    essentialOilListingFacets: essentialOilListingFacets,
    essentialOilListingLetterFilters: essentialOilListingLetterFilters,
    essentialOilListingSelectedLetter: essentialOilListingSelectedLetter
  };
}